export function isAnnouncement(file) {
    return (file === null || file === void 0 ? void 0 : file.resource_type) === 'announcement';
}
